import type { ElementKey } from '@/lib/experience'
import { ELEMENTS, ELEMENT_SITUATIONS } from '@/lib/experience'
import { motion } from 'framer-motion'
import { useState } from 'react'

interface Props {
  element: ElementKey
  onSelect: (situationIndex: number) => void
}

function StepPain({ element, onSelect }: Props) {
  const meta = ELEMENTS[element]
  const situations = ELEMENT_SITUATIONS[element]
  const [selected, setSelected] = useState<number | null>(null)

  const choose = (i: number) => {
    if (selected !== null) return
    setSelected(i)
    setTimeout(() => onSelect(i), 700)
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className="w-full max-w-2xl mx-auto"
    >
      <div className="text-center mb-10">
        <p className="text-[11px] tracking-[0.35em] uppercase font-body mb-3" style={{ color: meta.accentSoft }}>
          Elemento {meta.label} · Raiz
        </p>
        <h1 className="font-display type-section text-[var(--ink)] mb-5">
          Qual dessas situações mais se parece com o que você vive?
        </h1>
        <p className="text-[var(--ink-soft)] font-body italic type-label">
          Escolha apenas uma. A que mais ressoa agora.
        </p>
      </div>

      <div className="space-y-3">
        {situations.map((text, i) => {
          const isSelected = selected === i
          return (
            <motion.button
              key={i}
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 + i * 0.08 }}
              onClick={() => choose(i)}
              disabled={selected !== null}
              className={`choice-card w-full text-left p-4 sm:p-5 md:p-6 rounded-sm flex gap-3 sm:gap-4 items-start min-h-[64px] ${isSelected ? `selected ${meta.selectedClass}` : ''}`}
            >
              <span
                className="font-display numerals text-[20px] sm:text-[22px] leading-none pt-1 flex-shrink-0"
                style={{ color: meta.accentSoft }}
              >
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="font-body type-card text-[var(--ink)]">
                {text}
              </span>
            </motion.button>
          )
        })}
      </div>
    </motion.div>
  )
}

export default StepPain
